var map = {
	"./1.svg": 187,
	"./10.svg": 188,
	"./11.svg": 189,
	"./12.svg": 190,
	"./13.svg": 191,
	"./14.svg": 192,
	"./15.svg": 193,
	"./16.svg": 194,
	"./17.svg": 195,
	"./18.svg": 196,
	"./19.svg": 197,
	"./2.svg": 198,
	"./20.svg": 199,
	"./21.svg": 200,
	"./22.svg": 201,
	"./23.svg": 202,
	"./3.svg": 203,
	"./4.svg": 204,
	"./5.svg": 205,
	"./6.svg": 206,
	"./7.svg": 207,
	"./8.svg": 208,
	"./9.svg": 209,
	"./base.svg": 210,
	"./tombstone.svg": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;